import type { onNavigate } from '@otto-ec/global-resources/navigation';
import type { SelectionUpdate } from '@tilelist/application/ports/SelectionEvents.ts';
import { isCheckpoint, navigationInfo, relativeLocation } from './SelectionNavigation.browser.ts';

type NavigationEvent = Parameters<Parameters<typeof onNavigate.subscribe>[0]>[0];

export function handleSelectionNavigation(
    event: NavigationEvent,
    checkpoint: unknown,
    commit: (update: SelectionUpdate, destinationUrl: string) => void,
): void {
    if (event.type === 'popstate' && relativeLocation(event.from.url) === relativeLocation(event.destination.url))
        return;
    if (!isCheckpoint(checkpoint)) return;
    const info = navigationInfo(event.info);
    const source = event.type === 'popstate' ? 'historic' : info?.source;
    if (!source || info?.initialize) return;
    event.onComplete((result) => {
        if (!result.cancelled) commit({ selection: checkpoint, source }, event.destination.url.href);
    });
}
